package api.data.request

import dev.gitlive.firebase.firestore.FieldValue
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class DataUpdatedPropertyStatus(
//    @SerialName("id")
    var id: String = "",

//    @SerialName("status")
    var status: String = "",

//    @SerialName("isApproved")
    var isApproved: Boolean = false,

//    @SerialName("rejectedBy")
    var rejectedBy: String = "",

//    @SerialName("rejectedBy")
    var archivedBy: String = "",

//    @SerialName("rejectedBy")
    var pendingBy: String = "",

//    @SerialName("rejectionReason")
    var rejectionReason: String = "",

//    @SerialName("approvedBy")
    var approvedBy: String = "",

//    @SerialName("approvedOn")
    var approvedOn: Timestamp = Timestamp.now(),
)


fun DataUpdatedPropertyStatus.toHashMap(): HashMap<String, Any?> {
    return hashMapOf(
        "status" to status,
        "isApproved" to isApproved,
        "rejectedBy" to rejectedBy,
        "rejectionReason" to rejectionReason,
        "approvedBy" to approvedBy,
        "approvedOn" to FieldValue.serverTimestamp,
    )
}